export const ITEMS_PER_PAGE = 10;

export const INITIAL_FILTERS = {
  status: '',
  uuid_warehouse: '',
  order_number: '',
  date_from: '',
  date_to: '',
};

export const CONSUMPTION_STATUSES = {
  GENERATED: 'generated',
  CONFIRMED: 'confirmed',
  DELIVERED: 'delivered',
  REVERSED: 'reversed',
  CANCELLED: 'cancelled',
};

export const ACTIVE_CONSUMPTION_STATUSES = [
  CONSUMPTION_STATUSES.GENERATED,
  CONSUMPTION_STATUSES.CONFIRMED,
  CONSUMPTION_STATUSES.DELIVERED,
];

export const BLOCKING_CONSUMPTION_STATUSES = [
  CONSUMPTION_STATUSES.GENERATED,
];

export const GENERATE_CONSUMPTION_ORDER_STATUSES = [
  'stock_available',
  'ready_to_consume',
  'awaiting_transfer',
];

export const CONSUMPTION_STATUS_LABELS = {
  generated: 'Generado',
  confirmed: 'Confirmado',
  delivered: 'Entregado',
  reversed: 'Revertido',
  cancelled: 'Cancelado',
};

export const CONSUMPTION_ITEM_STATUS_LABELS = {
  consumed: 'Consumido',
  reversed: 'Revertido',
};

export const CONSUMPTION_UNIT_STATUS_LABELS = {
  pending_delivery: 'Pendiente de entrega',
  delivered: 'Entregado',
  reversed: 'Revertido',
};

export const INITIAL_GENERATE_CONSUMPTION_STATE = {
  uuid_warehouse: '',
  observations: '',
};

export const INITIAL_DELIVER_CONSUMPTION_STATE = {
  delivery_responsible: '',
  delivery_address: '',
  delivery_date: '',
  delivery_time: '',
  observations: '',
};

export const INITIAL_REVERSE_CONSUMPTION_STATE = {
  reason: '',
  observations: '',
};

export const VALIDATION_RULES = {
  REASON_MAX_LENGTH: 1000,
  OBSERVATIONS_MAX_LENGTH: 1000,
  RESPONSIBLE_MAX_LENGTH: 150,
  ADDRESS_MAX_LENGTH: 255,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    REQUIRED_REASON: 'El motivo es obligatorio',
    REQUIRED_RESPONSIBLE: 'El responsable es obligatorio',
    REQUIRED_ADDRESS: 'La dirección es obligatoria',
    REQUIRED_DATE: 'La fecha es obligatoria',
    REQUIRED_TIME: 'La hora es obligatoria',
  },
};
